<style scoped lang="scss">
  @import "../user";

</style>
<style>
@media screen and (max-width: 640px){
  .el-message-box{
    width: 90% !important;
  }
  .el-cascader-menu {
    width: 120px !important;
    min-width: 100px !important;
  }
}
</style>
<style scoped>
@import url("../../../assets/user_child_index.css");
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">用户基础信息<span :style="{fontSize: '14px', marginLeft: '20px', cursor: 'pointer'}"><a @click="viewContract">《服务协议》</a></span></h3>
      <ul class="info-lists">
        <li>
          <span><label>姓名</label>{{memberInfo.realName}}</span>
          <span class="text-primary" @click="modifyNameVisible = true">修改</span>
        </li>
        <li>
          <span><label>课题组：</label>{{memberInfo.researchGroup.name}}</span>
        </li>
        <li><span><label>积分：</label>{{points.availablePoints}}</span></li>
        <li><span><label>单位名称：</label>{{memberInfo.researchGroup.workUnit.name}}</span></li>
        <li>
          <span><label>手机号：</label>{{memberInfo.mobile}}</span>
          <span class="text-primary" @click="modifyPhoneVisible = true;timesCount = 0">修改</span>
        </li>
        <li>
          <span class="d-flex flex-1"><label>收货地址：</label>
            <span class="flex-1" v-if="memberInfo.deliveryAddress">
            {{memberInfo.deliveryAddress.province}}
            {{memberInfo.deliveryAddress.city}}
            {{memberInfo.deliveryAddress.county}}
            {{memberInfo.deliveryAddress.detail}}
          </span>
          </span>
          <span class="text-primary" @click="modifyAddressVisible = true">修改</span>
        </li>
        <li>
          <span><label>邮箱：</label>{{memberInfo.email}}</span>
          <span class="text-primary" @click="modifyEmailVisible = true;timesCount = 0">修改</span>
        </li>
        <li>
          <span><label>密码：</label>******</span>
          <span class="text-primary" @click="modifyPwdVisible = true">修改</span>
        </li>
        <!-- <li> -->
          <div style="width:100%">
            <label>抄送邮箱：</label>
<!--            <span class="text-primary" @click="addEmailVisible = true" v-if="memberInfo.copyEmails && memberInfo.copyEmails.length > 0">修改抄送邮箱</span>-->
            <span class="text-primary" style="margin-left: -2px;cursor: pointer;" @click="openCopyEmails">新增抄送邮箱</span>
            <p style="margin-left:70px">{{copyEmailsLists.join("；")}}</p>
            <!-- <dl class="email-lists">
              <dd v-for="(item, index) in copyEmailsLists" :key="index">{{item}}</dd>
            </dl> -->
          </div>
        <!-- </li> -->
      </ul>
    </section>
    <section>
      <h3 class="title">服务人员信息</h3>
      <ul class="info-lists">
        <li><span><label>分子产品销售：</label><span v-if="memberInfo.productSeller">{{memberInfo.productSeller.realName}}</span></span></li>
        <li v-show="memberInfo.deliveryType !== 'EXPRESS'"><span><label>配送员：</label><span v-if="memberInfo.courier">{{memberInfo.courier.realName}}</span></span></li>
        <li><span><label>服务产品销售：</label><span v-if="memberInfo.serveSeller">{{memberInfo.serveSeller.realName}}</span></span></li>
        <li><span><label>配送方式：</label>{{memberInfo.deliveryType === 'EXPRESS' ? '快递' : '指定配送员'}}</span></li>
      </ul>
    </section>
<!--    <section class="cs_go">-->
<!--      <h3 class="title">测序邮件接收规则</h3>-->
<!--      <div class="rules">-->
<!--        <el-radio-group v-model="receiveEmailRUles" @change="changeEmailRules">-->
<!--          <el-radio size="mini" :label="item.value" v-for="(item, index) in pageData.receiveRules" :key="index">{{item.label}}</el-radio>-->
<!--        </el-radio-group>-->
<!--      </div>-->
<!--    </section>-->
    <!--修改手机号弹框-->
    <el-dialog
      class="cs"
      title="修改手机号"
      :visible.sync="modifyPhoneVisible"
      width="50%">
      <el-form :model="mobileForm" ref="mobileForm" :rules="mobileFormRules" label-width="120px">
        <el-form-item label="手机号" prop="phone" required>
          <el-input v-model="mobileForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="d-flex">
            <el-input v-model="mobileForm.code" placeholder="请输入验证码"></el-input>
            <el-button class="ml20" @click="getCode" v-if="timesCount === 0">获取验证码</el-button>
            <el-button class="ml20" v-else>{{timesCount}}s</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyPhoneVisible = false;resetForm('mobileForm')">取消</el-button>
        <el-button type="primary" @click="bindConfirmMobile('mobileForm')">确定</el-button>
      </span>
    </el-dialog>
    <!--修改姓名弹框-->
    <el-dialog
      title="修改姓名"
      class="cs"
      :visible.sync="modifyNameVisible"
      width="50%">
      <el-form ref="nameForm" :model="nameForm" :rules="nameFormRules" label-width="120px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="nameForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyNameVisible = false;nameForm.name = memberInfo.realName">取消</el-button>
        <el-button type="primary" @click="bindConfirmName('nameForm')">确定</el-button>
      </span>
    </el-dialog>
    <!--修改邮箱弹框-->
    <el-dialog
      title="修改邮箱"
      class="cs"
      :visible.sync="modifyEmailVisible"
      width="50%">
      <el-form :model="emailForm" ref="emailForm" :rules="emailFormRules" label-width="120px">
        <el-form-item label="邮箱" prop="email" required>
          <el-input v-model="emailForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="d-flex">
            <el-input v-model="emailForm.code" placeholder="请输入验证码"></el-input>
            <el-button class="ml20" @click="getEmailCode" v-if="timesCount === 0">获取验证码</el-button>
            <el-button class="ml20" v-else>{{timesCount}}s</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyEmailVisible = false;resetForm('emailForm');">取消</el-button>
        <el-button type="primary" @click="bindConfirmEmail('emailForm')">确定</el-button>
      </span>
    </el-dialog>
    <!--新增抄送邮箱弹框-->
    <el-dialog
      title="新增抄送邮箱"
      class="cs"
      @close="closeCopyEmails"
      :visible.sync="addEmailVisible"
      width="50%">
      <el-form label-width="120px" v-if="memberInfo.copyEmails && memberInfo.copyEmails.length !== 0">
        <el-form-item :label="`抄送邮箱${index+1}`" v-for="(item, index) in memberInfo.copyEmails" :key="index" >
          <div class="d-flex flex-align-center">
            <el-input v-model="memberInfo.copyEmails[index]" placeholder="请输入邮箱" style="width:90%;"></el-input>
            <span class="el-icon-minus ml20 pointer" @click="delEmail(index)" v-show="index !== memberInfo.copyEmails.length - 1"></span>
            <span class="el-icon-plus ml20 pointer" @click="addEmail" v-show="index === memberInfo.copyEmails.length - 1"></span>
          </div>
        </el-form-item>
      </el-form>
      <el-form label-width="120px" v-else>
        <el-form-item :label="`抄送邮箱${index+1}`" v-for="(item, index) in newAddEmail" :key="index" >
          <div class="d-flex flex-align-center">
            <el-input v-model="newAddEmail[index]" placeholder="请输入邮箱" style="width:90%;"></el-input>
            <span class="el-icon-minus ml20 pointer" @click="delEmailNew(index)"></span>
            <span class="el-icon-plus ml20 pointer" @click="addEmailNew"></span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCopyEmails">取消</el-button>
        <el-button type="primary" @click="bindAddEmail('nameForm')">确定</el-button>
      </span>
    </el-dialog>
    <!--修改收货地址弹框-->
    <el-dialog
      title="修改收货地址"
      class="cs _user-page-address-dialog"
      :visible.sync="modifyAddressVisible"
      width="50%">
      <el-form :model="addressForm" ref="addressForm" :rules="addressFormRules" label-width="120px">
        <el-form-item label="请选择地址" prop="address">
          <el-cascader
            :value="addressForm.address"
            :options="cities"
            ref="myCascader"
            style="width: 100%"
            @change="handleAddressChange"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="detail">
          <el-input v-model="addressForm.detail" placeholder="请输入详细地址" :maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyAddressVisible = false">取消</el-button>
        <el-button type="primary" @click="bindConfirmAddress('addressForm')">确定</el-button>
      </span>
    </el-dialog>
    <!--修改密码弹框-->
    <el-dialog
      title="修改密码"
      class="cs"
      @close="modifyPwdVisible = false;resetForm('pwdForm')"
      :visible.sync="modifyPwdVisible"
      width="50%">
      <el-form :model="pwdForm" ref="pwdForm" :rules="pwdFormRules" label-width="120px">
        <el-form-item label="原始密码" prop="originalPwd">
          <el-input type="password" v-model="pwdForm.originalPwd" placeholder="请输入原始密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input type="password" v-model="pwdForm.newPwd" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmNewPwd">
          <el-input type="password" v-model="pwdForm.confirmNewPwd" placeholder="请输入确认新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyPwdVisible = false;resetForm('pwdForm')">取消</el-button>
        <el-button type="primary" @click="bindConfirmPwd('pwdForm')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { customerUsers, customerPoints, changeMobile, changeRealName, userRules, changePassword, changeAddress, changeCopyEmails, changeEmail } from '@/services/api.index'
import { getRegionTreeData } from '@/utils'
export default {
  data () {
    let checkMobile = (rule, value, callback) => {
      this.baseMethods.checkPhoneRules(value, callback)
    }
    let checkEmail = (rule, value, callback) => {
      this.baseMethods.checkEmailRules(value, callback)
    }
    return {
      radio: '',
      modifyPhoneVisible: false,
      modifyNameVisible: false,
      addEmailVisible: false,
      modifyEmailVisible: false,
      modifyAddressVisible: false,
      modifyPwdVisible: false,
      cities: [],
      memberInfo: {
        researchGroup: {
          workUnit: {},
          copyEmails: []
        }
      },
      newAddEmail: ["",],
      points: {},
      timesCount: 0,
      emailCount: 0,
      mobileForm: {
        phone: '',
        code: ''
      },
      receiveEmailRUles: '',
      nameForm: {
        name: ''
      },
      addEmailForm: {
        emails: ['']
      },
      emailForm: {
        email: '',
        code: ''
      },
      addressForm: {
        address: [],
        addressLabel: [],
        detail: ''
      },
      pwdForm: {
        originalPwd: '',
        newPwd: '',
        confirmNewPwd: ''
      },
      copyEmails: 1,
      copyEmailsLists: [],
      mobileFormRules: {
        phone: [{ validator: checkMobile, trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      nameFormRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
      },
      addEmailFormRules: {
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }]
      },
      emailFormRules: {
        email: [{ validator: checkEmail, trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      addressFormRules: {
        address: [{ required: true, message: '请选择地址', trigger: 'blur' }],
        detail: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
      },
      pwdFormRules: {
        originalPwd: [{ required: true, message: '请输入原始密码', trigger: 'blur' }],
        newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmNewPwd: [{ required: true, message: '请输入确认新密码', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getRegionInfo()
    this.getUserInfo()
    this.getPoints()
  },
  computed: {
    ...mapState(['pageData'])
  },
  methods: {
    async getRegionInfo() {
      const res = await getRegionTreeData()
      this.cities = res
    },
    getUserInfo () {
      customerUsers().then(res => {
        let data = res.data
        if (!res.data.copyEmails) {
          res.data.copyEmails = ['']
        }
        console.log(data)
        this.memberInfo = data
        this.copyEmailsLists = JSON.parse(JSON.stringify(data.copyEmails))
        this.baseMethods.setLocalObj('memberInfo', data)
        this.nameForm.name = data.realName
        const { provinceCode, cityCode, countyCode, detail } = data.deliveryAddress
        this.addressForm.address = [provinceCode, cityCode, countyCode]
        this.addressForm.detail = detail
        this.receiveEmailRUles = data.geneSeqEmailReceiveRule
      })
    },
    // 积分汇总
    getPoints () {
      customerPoints().then(res => {
        this.points = res.data
      })
    },
    // 发送验证码
    getCode () {
      const { phone } = this.mobileForm
      this.baseMethods.sendCode(phone, 'mobileForm', this)
    },
    // 发送邮箱验证码
    getEmailCode () {
      const { email } = this.emailForm
      this.baseMethods.sendEmailCode(email, 'emailForm', this)
    },
    // 确认修改手机号
    bindConfirmMobile (formName) {
      const { phone, code } = this.mobileForm
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changeMobile(phone, code).then(() => {
            this.$message.success('修改成功')
            this.modifyPhoneVisible = false
            this.memberInfo.mobile = phone
            window.open('https://www.masterbio.shop/member/logout')
          })
        }
      })
    },
    // 修改姓名
    bindConfirmName (formName) {
      const { name } = this.nameForm
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changeRealName(name).then(() => {
            this.$message.success('修改成功')
            this.modifyNameVisible = false
            this.memberInfo.realName = name
          })
        }
      })
    },
    // 确认修改邮箱
    bindConfirmEmail (formName) {
      const { email, code } = this.emailForm
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changeEmail(email, code).then(() => {
            this.$message.success('修改成功')
            this.modifyEmailVisible = false
            this.memberInfo.email = email
            window.open('https://www.masterbio.shop/member/logout')
          })
        }
      })
    },
    viewContract() {
      window.open(process.env.SHOP_URL + `/article/detail/14_0`)
    },
    // 删除抄送邮箱
    delEmail (index) {
      this.memberInfo.copyEmails.splice(index, 1)
    },
    // 添加抄送邮箱
    addEmail () {
      this.memberInfo.copyEmails.push('')
    },
    // 添加抄送邮箱-新增
    addEmailNew () {
      this.newAddEmail.push('')
    },
    // 删除抄送邮箱
    delEmailNew (index) {
      if(index > 0) {
        this.newAddEmail.splice(index, 1)
      }
    },
    // 新增邮箱
    bindAddEmail () {
      if(this.memberInfo.copyEmails.length === 0) {
        changeCopyEmails(this.newAddEmail).then(() => {
          this.$message.success('修改成功')
          this.copyEmailsLists = this.newAddEmail
          this.addEmailVisible = false
        })
      }else {
        changeCopyEmails(this.memberInfo.copyEmails).then(() => {
          this.$message.success('修改成功')
          this.copyEmailsLists = this.memberInfo.copyEmails
          this.addEmailVisible = false
        })
      }
    },
    handleAddressChange (value) {
      this.addressForm.address = value
    },
    // 修改收货地址
    bindConfirmAddress (formName) {
      const { address: [provinceCode, cityCode, countyCode], detail, addressLabel } = this.addressForm
      const [province, city, county] = this.$refs['myCascader'].getCheckedNodes()[0].pathLabels
      const params = {province, city, county, detail, provinceCode, cityCode, countyCode}
      this.$refs[formName].validate(async valid => {
        if (valid) {
          await changeAddress(params)
          this.$message.success('修改成功')
          this.modifyAddressVisible = false
          this.memberInfo.deliveryAddress.province = province
          this.memberInfo.deliveryAddress.city = city
          this.memberInfo.deliveryAddress.county = county
          this.memberInfo.deliveryAddress.detail = detail
          this.$store.dispatch('memberInfo')
        }
      })
    },
    // 修改密码
    bindConfirmPwd (formName) {
      const { originalPwd, newPwd, confirmNewPwd } = this.pwdForm
      if (confirmNewPwd !== newPwd) {
        this.$message.error('两次密码输入不一致')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changePassword(originalPwd, newPwd, confirmNewPwd).then(() => {
            this.$message.success('修改成功')
            this.modifyPwdVisible = false
            window.open('https://www.masterbio.shop/member/logout')
          })
        }
      })
    },
    changeEmailRules (value) {
      const memberInfo = this.baseMethods.getLocalObj('memberInfo')
      this.receiveEmailRUles = memberInfo.geneSeqEmailReceiveRule
      this.$confirm('确定变更邮件接收方式？').then(() => {
        this.receiveEmailRUles = value
        userRules(value).then(() => {
          this.$message.success('修改成功')
          this.$store.dispatch('memberInfo')
        })
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    openCopyEmails () {
      this.copyEmailsLists = JSON.parse(JSON.stringify(this.memberInfo.copyEmails))
      this.addEmailVisible = true
    },
    closeCopyEmails () {
      this.addEmailVisible = false
      this.memberInfo.copyEmails = this.copyEmailsLists
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/index.vue